module.exports = __webpack_public_path__ + "assets/img/3.000dbd72.png";